mybutton = document.getElementById("topnav-co-club");

if (mybutton) {
  mybutton.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });
}

const formGd = document.querySelector('form.ab-co-club-moments-game-decision');

function validateInputsGameDecision() {
  if (formGd) {
    const inputPlayer = formGd.querySelectorAll('input');

    for (let index = 0; index < inputPlayer.length; index++) {
      const elementIp = inputPlayer[index];

      elementIp.addEventListener('input', function (event) {
        const inputValue = event.target;
        const inputHost = formGd.querySelector('#edit-host');
        // console.log(inputHost);
        // console.dir(inputValue);
        if (inputValue.value.length < 3) {
          elementIp.classList.add('is-invalid');
        } else {
          elementIp.classList.remove('is-invalid');
          inputHost.classList.remove('is-invalid');
        }
      }); 
      
    }
  }
}

validateInputsGameDecision();